var ArticlesGrid,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

ArticlesGrid = (function() {
  function ArticlesGrid(options) {
    this.load_more = __bind(this.load_more, this);
    this.load = __bind(this.load, this);
    this.reload = __bind(this.reload, this);
    this.add_container = __bind(this.add_container, this);
    this.per_page = options.per_page != null ? options.per_page : 100;
    this.cart_enabled = options.cart_enabled != null ? true : false;
    this.info = options.info;
    Observable(this, 'loaded', false);
    Observable(this, 'loading', false);
    Observable(this, 'count', 0);
    Observable(this, 'page', 0);
    ObservableArray(this, 'articles');
    Observable(this, 'article');
    $(window).scroll((function(_this) {
      return function() {
        if (!_this.loaded()) {
          return;
        }
        if ($(window).scrollTop() !== ($(document).height() - $(window).height())) {
          return;
        }
        if (!(_this.count() > _this.articles().length)) {
          return;
        }
        return _this.load_more();
      };
    })(this));
  }

  ArticlesGrid.prototype.add_container = function(container, options) {
    this.container = container;
    return this.container.subscribe(this.load);
  };

  ArticlesGrid.prototype.reload = function() {
    return this.load();
  };

  ArticlesGrid.prototype.load = function(page, more, options) {
    if (page == null) {
      page = 0;
    }
    if (more == null) {
      more = void 0;
    }
    this.loading(true);
    if (this.container() === null) {
      this.loading(false);
      if (this.upload != null) {
        this.upload.disable();
      }
      this.articles.removeAll();
      return;
    }
    if (this.upload != null) {
      this.upload.enable();
    }
    if ($.isNumeric(page) !== true) {
      page = 0;
    }
    if (more === void 0) {
      this.loaded(false);
    }
    this.count(0);
    this.page(page);
    if (options == null) {
      options = {};
    }
    options.page = page;
    options.per_page = this.per_page;
    return this.container().articles(options, (function(_this) {
      return function(response) {
        var a, article, _i, _len, _ref;
        if (more === void 0) {
          _this.articles.removeAll();
        }
        _this.count(Number(response.count));
        if (response.articles !== void 0) {
          _ref = response.articles;
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            article = _ref[_i];
            a = Article(article);
            if (_this.cart_enabled) {
              a = Purchasable(a);
            }
            _this.articles.push(a);
          }
        }
        _this.loaded(true);
        _this.loading(false);
        if ((_this.count() - _this.articles().length) < _this.per_page && _this.count() > _this.articles().length) {
          return _this.load_more();
        }
      };
    })(this));
  };

  ArticlesGrid.prototype.load_more = function() {
    if ((this.page() * this.per_page) >= this.articles().length) {
      return;
    }
    return this.load(this.page() + 1, true);
  };

  return ArticlesGrid;

})();

//# sourceMappingURL=articlesgrid.js.map
